import React, {Component} from 'react';
import PropTypes from "prop-types";
import Select from 'react-select';


class GroupingSelector extends Component {

    static propTypes = {
        translate: PropTypes.func.isRequired,
        onGroupingSelected: PropTypes.func.isRequired,
    };

    static defaultProps = {
        currentGrouping: 'HN',
    };

    constructor(props) {

        super(props);

        this.state = {
            currentGroupingId: props.currentGrouping ? props.currentGrouping : null
        };

        this.translate = this.props.translate;

        this.selectGrouping = this.selectGrouping.bind(this);

    }

    selectGrouping(g) {

        let grouping = this.getGroupingById(g.value);

        if (String(this.state.currentGrouping) === String(grouping.id)) return;

        this.setState({
            currentGroupingId: grouping.id,
        });

        if (this.props.onGroupingSelected) this.props.onGroupingSelected(grouping);

    }

    getGroupings() {

        return [
            {id: 'HN', name: this.translate('head') + ' & ' + this.translate('needle')},
            {id: 'H',  name: this.translate('head')},
            {id: 'N',  name: this.translate('needle')}
        ];

    }

    getGroupingById(id) {

        let groupings = this.getGroupings();

        for (let ix in groupings) {
            let g = groupings[ix];

            if (String(g.id) === String(id)) return g;
        }

        return false;

    }

    getOptions() {

        let groupings = this.getGroupings();

        let opt = groupings.map(g => {
            return {
                value: String(g.id),
                label: g.name
            }
        });

        return opt;

    }

    render() {
        let opts = this.getOptions();
        const selectedOption = opts.find(o => o.value === String(this.state.currentGroupingId)) || null;

        return (
            <Select
                name="form-grouping-selector"
                className="chosen-container chosen-container-single"
                style={{width: '260px'}}
                options={opts}
                onChange={this.selectGrouping}
                value={selectedOption}
                clearable={false}
                placeholder={this.translate('select') + '...'}
                noResultsText={this.translate('noResultsFound')}
            />
        );
    }

}

export default GroupingSelector;